import Vue from 'vue'
import dateTools from 'common/javascript/tools/dateTools'
import moneyTools from 'common/javascript/tools/moneyTools'
import { MY_ZETRIX_LOGO } from '../config/enumeration/index'
/* 过滤器 start */
// 时间戳转时间，具体到天

function clearDecimalsEndZero (amount) {
  let pointIndex = amount.lastIndexOf('.')
  let pointPart = amount.substring(pointIndex + 1, 7)
  return pointPart.replace(/0+$/, '')
}

/**
 * 整数转千分位
 */
function interger2Thousandth (interger) {
  var re = /(-?\d+)(\d{3})/
  while (re.test(interger)) {
    interger = interger.replace(re, '$1,$2')
  }
  return interger
}

Vue.filter('txType', function (value) {
  if (value === null || typeof value === 'undefined') return
  if (value === 'PAY_COIN') {
    return MY_ZETRIX_LOGO
  } else if (value === 'CONTRACT') {
    return 'CONSENSUS'
  } else if (value === 'ISSUE_ASSET' || value === 'PAY_ASSET') {
    return 'TOKEN'
  } else if (value === 'CREATE_ACCOUNT') {
    return 'ACCOUNT'
  }
})
Vue.filter('txTypeToken', function (value) {
  if (value === null || typeof value === 'undefined') return
  if (value === 'transfer') {
    return 'TRANSFER'
  } else if (value === 'mint') {
    return 'MINT'
  } else if (value === 'burn') {
    return 'BURN'
  }
})
Vue.filter('blockSeq', function (value) {
  if (value === null || typeof value === 'undefined') return
  return '#' + value
})
Vue.filter('txCountUnit', function (value) {
  if (value === null || typeof value === 'undefined') return
  return value + ' 笔'
})
Vue.filter('tokenUnit', function (value) {
  if (value === null || typeof value === 'undefined') return
  return value + ` ${MY_ZETRIX_LOGO}`
})
Vue.filter('accountType', function (value) {
  if (value === null || typeof value === 'undefined') return
  var arr = [null, '普通账户', '合约账户', '联名账户'] // 1：普通账户；2：合约账户；3：联名账户
  return arr[value]
})
Vue.filter('amount2Thousandth', function (amount) {
  if (amount === 0 || amount === '0') return 0
  if (amount === null || typeof amount === 'undefined') return
  let pointIndex = (amount.lastIndexOf('.') !== -1 ? amount.lastIndexOf('.') : amount.length)
  let thousandth = interger2Thousandth(amount.substring(0, pointIndex))
  let decimals = clearDecimalsEndZero(amount.substring(pointIndex, amount.length))
  if (thousandth.length === 0 && decimals.length === 0) return 0
  return ((thousandth.length === 0) ? '0' : thousandth) + (decimals.length === 0 ? '' : '.' + decimals)
})
Vue.filter('simplifyAddress', function (value) {
  if (value === '' || value === null) {
    return '--'
  } else if (value.length < 6) {
    return value
  }
  return value.substring(0, 4) + '***' + value.substring((value.length - 4), value.length)
})

Vue.filter('simplifyAddressZTX3', function (value) {
  if (value === '' || value === null) {
    return '--'
  } else if (value.length < 6) {
    return value
  }
  return value.substring(0, 10) + '***' + value.substring((value.length - 1), value.length)
})

Vue.filter('simplifyAddressZTX3', function (value) {
  // Null: ZTX3*0000
  // Check if the value is null or an empty string
  if (value === '' || value === null) {
    return '--'
  } else if (value.length < 6) { // Check if the value is less than 6 characters, return as is
    return value
  } else {  // Default case: show the value partially obscured
    return value.substring(0, 10) + '***' + value.substring(value.length - 4)
  }
})

Vue.filter('simplifyAddressZTX3NoLink', function (value) {
  // Null: ZTX3*0000
  // Check if the value is null or an empty string
  if (value === '' || value === null) {
    return '--'
  } else if (value.length < 6) { // Check if the value is less than 6 characters, return as is
    return value
  } else if (value.startsWith('ZTX3')) { // Ensure it starts with 'ZTX3'
    return value.substring(0, 4) + '***' + value.substring(4, 8) // Return ZTX3*0000
  } else {  // Default case for other values
    return value.substring(0, 8) + '***' + value.substring(value.length - 6)
  }
})

Vue.filter('formatNFTTokenID', function (value) {
  if (!value || typeof value !== 'string') {
    return '--'
  } else if (value.length < 6) {
    return value
  }
  return value.substring(0, 4) + '...' + value.substring(value.length - 4, value.length)
})
Vue.filter('formatTxHash', function (value) {
  if (value === '' || value === null) {
    return '--'
  } else if (value.length < 6) {
    return value
  }
  return value.substring(0, 4) + '...' + value.substring((value.length - 4), value.length)
})

// 日期格式化 YYYY-MM-DD HH:mm:ss
Vue.filter('dateFormaterPrecise', function (value) {
  return dateTools.dateFormater(value / 1000, 'YYYY.MM.DD HH:mm:ss')
})
// 日期格式化
Vue.filter('dateFormaterPreciseZero', function (value) {
  return dateTools.dateFormater(value, 'YYYY.MM.DD HH:mm:ss')
})
// 数字格式化
Vue.filter('tokenFormat', function (value) {
  if (value === null || typeof value === 'undefined') return '--'
  let result = ''
  let data = value / 1000000
  result = moneyTools.commafy(data)
  return result
})

Vue.filter('tokenFormatDecimal', function (tokenInfo) {
  let supply = tokenInfo.supply
  let decimals = tokenInfo.decimals
  if (supply === null || typeof supply === 'undefined') return '--'
  if (decimals === null || typeof decimals === 'undefined') return '--'
  let result = ''
  let data = supply / Math.pow(10, decimals)
  result = moneyTools.commafy(data)
  return result
})

// 人性化时间提示
Vue.filter('hommizationTime', function (value) {
  return dateTools.formatTime(value / 1000000)
})
Vue.filter('timestampToDay', function (value) {
  var time = new Date(parseInt(value))
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  y = isNaN(y) ? '0000' : y
  m = isNaN(m) ? '00' : m
  d = isNaN(d) ? '00' : d
  return y + '年' + m + '月' + d + '日'
})
// 时间戳转时间，具体到天
Vue.filter('timestampToDateDay', function (value) {
  return dateTools.dateFormater(value, 'YYYY.MM.DD')
})
// 时间戳转时间
Vue.filter('timestampToDate', function (value) {
  var time = new Date(parseInt(value))
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  var h = time.getHours() + ''
  var mm = time.getMinutes() + ''
  var s = time.getSeconds() + ''

  if (h.length === 1) {
    h = '0' + h
  }
  if (mm.length === 1) {
    mm = '0' + mm
  }
  if (s.length === 1) {
    s = '0' + s
  }
  y = isNaN(y) ? '0000' : y
  m = isNaN(m) ? '00' : m
  d = isNaN(d) ? '00' : d
  h = isNaN(h) ? '00' : h
  mm = isNaN(mm) ? '00' : mm
  s = isNaN(s) ? '00' : s
  return y + '年' + m + '月' + d + '日 ' + h + ':' + mm + ':' + s
})
// 时间戳转换为精确到秒
Vue.filter('timestampToDateStyle', function (value) {
  return dateTools.dateFormater(value, 'YYYY.MM.DD HH:mm:ss')
})
// 千分位+小数点后两位 + 缩小times倍
Vue.filter('moneyShow', function (value, times) {
  value = isNaN(value) || value === null || typeof value === 'undefined' ? '' : value
  if (value !== '') {
    times = times || 1
    var res = Vue.$moneyt.moneyShow(value / times)
  }
  return res
})
// 千分位+小数点可到四位 + 缩小times倍
Vue.filter('moneyShowFour', function (value, times) {
  value = isNaN(value) || value === null || typeof value === 'undefined' ? '' : value
  if (value !== '') {
    times = times || 1
    var res = Vue.$moneyt.moneyShowFour(value / times)
  }
  return res
})

// 千分位显示数字
Vue.filter('commafy', function (value) {
  value = isNaN(value) || value === null || typeof value === 'undefined' ? 0 : value
  var res = Vue.$moneyt.commafy(value)
  return res
})

// 数据为空的处理
Vue.filter('dealNull', function (value) {
  if (value === '' || value === null) {
    return '无'
  } else {
    return value
  }
})

function vfilter () {
}
export default vfilter
